/**
 * PocketFiler - Japanese (ja) Translation File
 * Complete translation - all keys from en.js
 */

const ja = {
  "nav.login": "ログイン",
  "nav.signup": "始める",
  "nav.logout": "ログアウト",
  "nav.dashboard": "ダッシュボード",
  "nav.virtualOffices": "バーチャルオフィス",
  "nav.clients": "クライアント",
  "nav.deals": "取引",
  "nav.documents": "ドキュメント",
  "nav.messages": "メッセージ",
  "nav.settings": "設定",
  "nav.invoices": "請求書",
  "nav.templates": "テンプレート",
  "nav.tasks": "タスク",
  "nav.meetings": "会議",
  "nav.analytics": "分析",
  "landing.badge": "AI搭載取引プラットフォーム",
  "landing.hero.title": "あらゆる言語で重要な取引を成立",
  "landing.hero.titleHighlight": "AIで",
  "landing.hero.subtitle": "PocketFilerは、企業や個人がグローバル貿易から地元の自動車販売、保険ポリシーまで、文書中心の高信頼性取引を行えるよう支援します。AI翻訳、文書ワークフロー、すべての取引のためのディールルームを提供します。",
  "landing.hero.cta.start": "無料で始める",
  "landing.hero.cta.demo": "仕組みを見る",
  "landing.useCases.title": "グローバル貿易、地域サービス、大規模な個人取引のために構築",
  "landing.useCases.subtitle": "海外から商品を輸入する場合でも、地元で車を売る場合でも、PocketFilerは自信を持って取引を成立させるツールを提供します。",
  "landing.useCases.globalTrade.title": "グローバル貿易と製造",
  "landing.useCases.globalTrade.desc": "海外サプライヤーを見つけて協力し、コンプライアンス文書を収集し、リアルタイム翻訳でディールルームで交渉します。",
  "landing.useCases.insurance.title": "保険、融資、専門サービス",
  "landing.useCases.insurance.desc": "クライアントを招待してID、明細書、フォームを母国語でアップロードさせ、バーチャルオフィスですべての文書とメッセージを追跡します。",
  "landing.useCases.realEstate.title": "不動産取引",
  "landing.useCases.realEstate.desc": "買い手とテナントを複数の言語で申請、開示、契約を通じてガイドし、すべてを取引ごとに1つのディールルームで処理します。",
  "landing.useCases.vehicle.title": "プライベート車両・資産販売",
  "landing.useCases.vehicle.desc": "ディールルームとAI生成契約書を使用して、車、機器、その他の高額品の売買文書を処理します。",
  "landing.audience.title": "個人とチームの両方のために設計",
  "landing.audience.individuals.title": "個人向け",
  "landing.audience.individuals.bullet1": "自動車購入、機器、高額品などの重要な一回限りの取引を明確な記録で完了します。",
  "landing.audience.individuals.bullet2": "シンプルで安全なリンクを使用して、スマートフォンから文書をアップロードし、契約書を確認します。",
  "landing.audience.individuals.bullet3": "取引完了後も、各取引のすべてのメッセージ、ファイル、契約書ドラフトを一箇所に保管します。",
  "landing.audience.teams.title": "企業・チーム向け",
  "landing.audience.teams.bullet1": "各サービスライン（保険、不動産、融資、輸入）のカスタムチェックリスト付きバーチャルオフィスを設定します。",
  "landing.audience.teams.bullet2": "あらゆる言語のクライアントを招待して文書をアップロードし、契約書に署名し、ディールルームでコミュニケーションします。",
  "landing.audience.teams.bullet3": "チームにタイムライン、AIサマリー、各取引の完全な履歴を備えた共有ワークスペースを提供します。",
  "landing.howItWorks.title": "PocketFilerがあらゆる取引で機能する方法",
  "landing.howItWorks.subtitle": "取引をより速く、摩擦なく成立させるために連携する4つの強力な機能。",
  "landing.howItWorks.concierge.title": "AIコンシェルジュ",
  "landing.howItWorks.concierge.desc": "AIアシスタントがビジネスを学習し、適切なバーチャルオフィスを設定し、各取引タイプの文書チェックリストを構成します。",
  "landing.howItWorks.translation.title": "自動翻訳",
  "landing.howItWorks.translation.desc": "メッセージと主要コンテンツが当事者間で即座に翻訳され、買い手、売り手、クライアントが自分の言語でコミュニケーションできます。",
  "landing.howItWorks.documents.title": "スマートドキュメント",
  "landing.howItWorks.documents.desc": "クライアントがスマートフォンから文書をアップロードすると、AIが主要フィールドを抽出し、品質をチェックし、取引を遅らせる前に問題にフラグを付けます。",
  "landing.howItWorks.dealRooms.title": "ディールルームと契約",
  "landing.howItWorks.dealRooms.desc": "各取引には、タイムライン、メッセージ、文書、レビューして最終化できるAI生成契約書ドラフトを備えた専用ルームが提供されます。",
  "landing.cta.title": "次の取引を成立させる準備はできましたか？",
  "landing.cta.subtitle": "PocketFilerを使用して重要な取引を自信を持って処理する企業や個人に参加しましょう。",
  "landing.cta.button": "無料アカウントを作成",
  "landing.footer.tagline": "重要な取引をシンプルに。",
  "language.picker.title": "言語を選択してください",
  "language.picker.subtitle": "すべての説明、メッセージ、契約をこの言語で表示します。他の人は自分の言語を選択できます。AIが翻訳を処理します。",
  "language.picker.continue": "続ける",
  "language.picker.playSample": "サンプルを再生",
  "language.picker.playing": "再生中...",
  "language.picker.confirmation": "{language}を選択しました。すべてをこの言語で表示します。他の当事者は自分の言語を選択できます。PocketFilerはメッセージ、文書、契約を翻訳して全員が理解できるようにします。",
  "language.toast.saved": "言語が保存されました！変更するには、プロフィールの設定に移動してください。",
  "language.confirm.title": "言語を確認",
  "language.confirm.subtitle": "この言語はすべてのUI、メッセージ、契約に使用されます。",
  "language.confirm.change": "言語を変更",
  "language.confirm.continue": "続ける",
  "language.confirm.chineseNote": "注意：簡体字中国語（简体中文）を選択しました。繁体字中国語をご希望の場合は、選択を変更してください。",
  "auth.login.title": "おかえりなさい",
  "auth.login.subtitle": "PocketFilerアカウントにログイン",
  "auth.login.email": "メール",
  "auth.login.password": "パスワード",
  "auth.login.submit": "ログイン",
  "auth.login.noAccount": "アカウントをお持ちでないですか？",
  "auth.login.signupLink": "登録",
  "auth.login.error": "メールまたはパスワードが無効です",
  "auth.signup.title": "アカウントを作成",
  "auth.signup.subtitle": "あらゆる言語で取引を始める",
  "auth.signup.name": "氏名",
  "auth.signup.email": "メール",
  "auth.signup.password": "パスワード",
  "auth.signup.confirmPassword": "パスワードを確認",
  "auth.signup.companyName": "会社名",
  "auth.signup.companyType": "業種",
  "auth.signup.submit": "アカウントを作成",
  "auth.signup.hasAccount": "すでにアカウントをお持ちですか？",
  "auth.signup.loginLink": "ログイン",
  "auth.signup.terms": "登録することで、利用規約とプライバシーポリシーに同意したことになります。",
  "dashboard.title": "ダッシュボード",
  "dashboard.welcome": "おかえりなさい、{name}さん",
  "dashboard.aiSummary.title": "AIサマリー",
  "dashboard.aiSummary.generating": "サマリーを生成中...",
  "dashboard.stats.totalDeals": "総取引数",
  "dashboard.stats.activeDeals": "進行中の取引",
  "dashboard.stats.totalClients": "総クライアント数",
  "dashboard.stats.documentsProcessed": "処理済み文書",
  "dashboard.recentDeals.title": "最近の取引",
  "dashboard.recentDeals.viewAll": "すべて表示",
  "dashboard.recentDeals.empty": "まだ取引がありません。最初の取引を作成して始めましょう。",
  "dashboard.recentClients.title": "最近のクライアント",
  "dashboard.recentClients.viewAll": "すべて表示",
  "dashboard.recentClients.empty": "まだクライアントがいません。最初のクライアントを招待して始めましょう。",
  "dashboard.quickActions.title": "クイックアクション",
  "dashboard.quickActions.createDeal": "取引を作成",
  "dashboard.quickActions.inviteClient": "クライアントを招待",
  "dashboard.quickActions.createOffice": "バーチャルオフィスを作成",
  "offices.title": "バーチャルオフィス",
  "offices.subtitle": "サービスタイプ別にビジネスを整理",
  "offices.create": "バーチャルオフィスを作成",
  "offices.empty.title": "まだバーチャルオフィスがありません",
  "offices.empty.desc": "最初のバーチャルオフィスを作成して、取引とクライアントを整理しましょう。",
  "offices.card.clients": "{count}人のクライアント",
  "offices.card.deals": "{count}件の取引",
  "offices.card.checklist": "チェックリスト項目",
  "offices.checklist": "文書チェックリスト",
  "offices.noChecklist": "必要な文書なし",
  "offices.dialog.title": "バーチャルオフィスを作成",
  "offices.dialog.desc": "特定のサービスタイプ用の新しいワークスペースを設定",
  "offices.dialog.name": "オフィス名",
  "offices.dialog.namePlaceholder": "例：保険請求、不動産販売",
  "offices.dialog.type": "オフィスタイプ",
  "offices.dialog.description": "説明",
  "offices.dialog.descriptionPlaceholder": "このオフィスが処理する内容を説明...",
  "offices.dialog.checklist": "文書チェックリスト",
  "offices.dialog.checklistHelp": "必要な文書のAI生成チェックリスト",
  "offices.dialog.addItem": "項目を追加",
  "offices.dialog.generateChecklist": "AIで生成",
  "offices.dialog.creating": "作成中...",
  "offices.dialog.create": "オフィスを作成",
  "offices.form.name": "オフィス名",
  "offices.form.namePlaceholder": "例：保険サービス、不動産など",
  "offices.form.description": "説明",
  "offices.form.descPlaceholder": "このオフィスでどのような取引を処理しますか？",
  "offices.form.checklistPlaceholder": "必要な文書を追加...",
  "offices.ai.title": "AIアシスト設定",
  "offices.ai.desc": "AIコンシェルジュがビジネスニーズについて質問し、完璧なバーチャルオフィスの設定をお手伝いします。",
  "offices.ai.manual": "手動で設定",
  "offices.ai.start": "AIセットアップを開始",
  "offices.ai.startOnboarding": "バーチャルオフィスの設定を手伝ってください",
  "offices.ai.suggestion": "AIの提案",
  "offices.ai.acceptSuggestion": "承諾してオフィスを作成",
  "offices.ai.inputPlaceholder": "回答を入力...",
  "clients.title": "クライアント",
  "clients.subtitle": "クライアントと招待を管理",
  "clients.invite": "クライアントを招待",
  "clients.empty.title": "まだクライアントがいません",
  "clients.empty.desc": "最初のクライアントを招待して始めましょう。",
  "clients.table.name": "名前",
  "clients.table.client": "クライアント",
  "clients.table.contact": "連絡先",
  "clients.table.office": "オフィス",
  "clients.table.language": "言語",
  "clients.table.status": "ステータス",
  "clients.table.actions": "アクション",
  "clients.status.invited": "招待済み",
  "clients.status.active": "アクティブ",
  "clients.status.completed": "完了",
  "clients.dialog.title": "新しいクライアントを招待",
  "clients.dialog.name": "クライアント名",
  "clients.dialog.email": "メールアドレス",
  "clients.dialog.phone": "電話番号",
  "clients.dialog.office": "バーチャルオフィス",
  "clients.dialog.language": "希望言語",
  "clients.dialog.sending": "招待状を送信中...",
  "clients.dialog.send": "招待状を送信",
  "clients.toast.invited": "{name}に招待状を送信しました",
  "clients.toast.deleted": "クライアントが削除されました",
  "clients.toast.linkCopied": "招待リンクがクリップボードにコピーされました",
  "clients.invite.step1Title": "新しいクライアントを招待",
  "clients.invite.step2Title": "招待メッセージのプレビュー",
  "clients.invite.step3Title": "招待が送信されました！",
  "clients.invite.step1Desc": "クライアントの連絡先情報を入力",
  "clients.invite.step2Desc": "招待メッセージを確認・カスタマイズ",
  "clients.invite.step3Desc": "クライアントと招待リンクを共有",
  "clients.invite.nameLabel": "クライアント名",
  "clients.invite.namePlaceholder": "例：山田太郎",
  "clients.invite.contactMethod": "連絡方法",
  "clients.invite.phone": "電話番号",
  "clients.invite.customNote": "カスタムメモ",
  "clients.invite.customNotePlaceholder": "このクライアントへの特別な指示...",
  "clients.invite.previewMessage": "メッセージプレビュー",
  "clients.invite.aiGenerated": "AI生成招待メッセージ",
  "clients.invite.messagePreview": "メッセージプレビュー",
  "clients.invite.messageEditHint": "送信前にこのメッセージを編集できます",
  "clients.invite.documentsRequested": "リクエストされた文書",
  "clients.invite.regenerate": "メッセージを再生成",
  "clients.invite.sendInvite": "招待を送信",
  "clients.invite.linkCreated": "招待リンクが作成されました！",
  "clients.invite.linkCopiedToClipboard": "リンクがクリップボードにコピーされました",
  "clients.invite.shareLink": "メール、SMS、または直接このリンクをクライアントと共有してください",
  "clients.invite.inviteAnother": "別のクライアントを招待",
  "clients.invite.success": "クライアントが招待されました！",
  "clients.invite.linkCopied": "招待リンクがコピーされました！",
  "clients.invite.yourAgent": "担当者",
  "clients.invite.defaultOffice": "当社オフィス",
  "deals.title": "取引",
  "deals.subtitle": "取引を追跡・管理",
  "deals.create": "取引を作成",
  "deals.empty.title": "まだ取引がありません",
  "deals.empty.desc": "最初の取引を作成して始めましょう。",
  "deals.search": "取引を検索...",
  "deals.filter.all": "すべての取引",
  "deals.filter.active": "進行中",
  "deals.filter.pending": "保留中",
  "deals.filter.closed": "完了",
  "deals.column.draft": "下書き",
  "deals.column.active": "進行中",
  "deals.column.pending": "保留中",
  "deals.column.closed": "完了",
  "deals.card.documents": "{count}件の文書",
  "deals.card.messages": "{count}件のメッセージ",
  "deals.dialog.title": "新しい取引を作成",
  "deals.dialog.dealTitle": "取引タイトル",
  "deals.dialog.dealTitlePlaceholder": "例：車両購入 - Honda Civic 2023",
  "deals.dialog.client": "クライアント",
  "deals.dialog.office": "バーチャルオフィス",
  "deals.dialog.type": "取引タイプ",
  "deals.dialog.notes": "メモ",
  "deals.dialog.notesPlaceholder": "この取引に関するメモを追加...",
  "deals.dialog.creating": "作成中...",
  "deals.dialog.create": "取引を作成",
  "dealRoom.back": "取引に戻る",
  "dealRoom.readOnly.title": "読み取り専用",
  "dealRoom.readOnly.closedMessage": "この取引は完了しました。ディールルームは参照および監査目的で読み取り専用になっています。",
  "dealRoom.readOnly.cancelledMessage": "この取引はキャンセルされました。ディールルームは参照および監査目的で読み取り専用になっています。",
  "dealRoom.tabs.messages": "メッセージ",
  "dealRoom.tabs.documents": "文書",
  "dealRoom.tabs.contract": "契約書",
  "dealRoom.timeline.title": "アクティビティタイムライン",
  "dealRoom.timeline.empty": "まだアクティビティがありません",
  "dealRoom.details.title": "取引詳細",
  "dealRoom.details.notes": "メモ",
  "dealRoom.details.type": "タイプ",
  "dealRoom.details.documents": "文書",
  "dealRoom.details.messages": "メッセージ",
  "dealRoom.aiSummary.title": "AIサマリー",
  "dealRoom.aiSummary.generating": "サマリーを生成中...",
  "dealRoom.messages.empty": "まだメッセージがありません。会話を始めましょう。",
  "dealRoom.messages.placeholder": "メッセージを入力...",
  "dealRoom.messages.send": "送信",
  "dealRoom.messages.sending": "送信中...",
  "dealRoom.messages.showOriginal": "原文を表示",
  "dealRoom.messages.showTranslation": "翻訳を表示",
  "dealRoom.messages.translatedFrom": "{language}から翻訳",
  "dealRoom.messages.suggestReply": "返信を提案",
  "dealRoom.documents.empty": "まだ文書がアップロードされていません。",
  "dealRoom.documents.upload": "文書をアップロード",
  "dealRoom.documents.uploading": "アップロード中...",
  "dealRoom.documents.analyze": "分析",
  "dealRoom.documents.analyzing": "分析中...",
  "dealRoom.documents.download": "ダウンロード",
  "dealRoom.documents.delete": "削除",
  "dealRoom.documents.pending": "分析待ち",
  "dealRoom.documents.analyzed": "分析済み",
  "dealRoom.documents.aiAnalysis": "AI文書分析",
  "dealRoom.documents.type": "文書タイプ",
  "dealRoom.documents.confidence": "信頼度",
  "dealRoom.documents.summary": "サマリー",
  "dealRoom.documents.issues": "問題点",
  "dealRoom.contract.empty.title": "まだ契約書が生成されていません",
  "dealRoom.contract.empty.desc": "この取引のAI契約書ドラフトを生成します。",
  "dealRoom.contract.generate": "契約書ドラフトを生成",
  "dealRoom.contract.regenerate": "契約書を再生成",
  "dealRoom.contract.generating": "生成中...",
  "dealRoom.contract.aiLabel": "AI生成契約書ドラフト",
  "dealRoom.contract.language": "言語",
  "dealRoom.contract.copy": "コピー",
  "dealRoom.contract.copied": "クリップボードにコピーしました",
  "dealRoom.contract.type": "契約書タイプ",
  "dealRoom.contract.generated": "生成日",
  "dealRoom.contract.languages": "言語",
  "dealRoom.contract.status": "ステータス",
  "dealRoom.contract.notice": "AI文書分析：選択した言語間で直接の同等語がない条項が1つ以上あります。説明的な言語を使用しました。これらのセクションを注意深く確認し、必要に応じて相手方に確認してください。",
  "dealRoom.contract.dialog.title": "契約書ドラフトを生成",
  "dealRoom.contract.dialog.desc": "AIが取引詳細に基づいてバイリンガル契約書を生成します。",
  "dealRoom.contract.dialog.disclaimer": "これはレビュー目的のAI生成ドラフトです。署名前に法律専門家にレビューしてもらってください。",
  "dealRoom.contract.dialog.type": "契約書タイプ",
  "dealRoom.contract.dialog.languages": "言語",
  "dealRoom.contract.dialog.languagesHelp": "バイリンガル契約書の2つの言語を選択してください。すべてのTier 1言語が完全にサポートされています。",
  "dealRoom.contract.dialog.primary": "プライマリ",
  "dealRoom.contract.dialog.secondary": "セカンダリ",
  "dealRoom.contract.dialog.terms": "特別条件",
  "dealRoom.contract.dialog.termsPlaceholder": "特別な条件を追加...",
  "dealRoom.contract.dialog.generate": "契約書を生成",
  "dealRoom.contract.dialog.generating": "生成中...",
  "dealRoom.status.change": "ステータスを変更",
  "dealRoom.status.dialog.title": "取引ステータスを変更",
  "dealRoom.status.dialog.from": "変更前",
  "dealRoom.status.dialog.to": "変更後",
  "dealRoom.status.dialog.reason": "理由（任意）",
  "dealRoom.status.dialog.reasonPlaceholder": "なぜステータスを変更しますか？",
  "dealRoom.status.dialog.confirm": "変更を確認",
  "dealRoom.status.dialog.changing": "変更中...",
  "dealRoom.status.toast.changed": "ステータスが{status}に変更されました",
  "dealRoom.upgrade.title": "ビジネスにアップグレード",
  "dealRoom.upgrade.desc": "契約書生成にはビジネスプランが必要です。",
  "dealRoom.upgrade.features": "ビジネスでは以下が利用可能：",
  "dealRoom.upgrade.feature1": "AI生成契約書ドラフト",
  "dealRoom.upgrade.feature2": "高度な文書分析",
  "dealRoom.upgrade.feature3": "優先サポート",
  "dealRoom.upgrade.button": "今すぐアップグレード",
  "settings.title": "設定",
  "settings.subtitle": "アカウントと組織を管理",
  "settings.tabs.profile": "プロフィール",
  "settings.tabs.organization": "組織",
  "settings.profile.title": "プロフィール設定",
  "settings.profile.subtitle": "個人情報を管理",
  "settings.profile.name": "氏名",
  "settings.profile.email": "メール",
  "settings.profile.emailNote": "メールは変更できません",
  "settings.profile.language": "希望言語",
  "settings.profile.languageHelp": "すべてのUI、メッセージ、契約がこの言語で表示されます。",
  "settings.profile.save": "変更を保存",
  "settings.profile.saving": "保存中...",
  "settings.profile.saved": "プロフィールが更新されました",
  "settings.org.title": "組織設定",
  "settings.org.subtitle": "ビジネス情報を管理",
  "settings.org.name": "組織名",
  "settings.org.type": "業種",
  "settings.org.billingEmail": "請求先メール",
  "settings.org.plan": "プラン",
  "settings.org.verification": "認証ステータス",
  "settings.org.save": "変更を保存",
  "settings.org.saving": "保存中...",
  "settings.org.saved": "組織が更新されました",
  "settings.org.noOrg": "組織が見つかりません",
  "invite.language.title": "言語を選択してください",
  "invite.language.subtitle": "すべての説明をお客様の言語で表示します。",
  "invite.welcome.title": "ようこそ",
  "invite.welcome.subtitle": "お客様の文書を受け取る準備ができています。",
  "invite.welcome.time": "5〜10分",
  "invite.welcome.timeLabel": "予想所要時間",
  "invite.welcome.secure": "安全で無料",
  "invite.welcome.secureDesc": "お客様の文書は暗号化されています。このサービスは無料です。",
  "invite.welcome.start": "アップロードを開始",
  "invite.documents.needed": "必要な文書",
  "invite.upload.title": "文書をアップロード",
  "invite.upload.dragDrop": "ここにファイルをドラッグ＆ドロップ、またはクリックして選択",
  "invite.upload.or": "または",
  "invite.upload.takePhoto": "画像",
  "invite.upload.browse": "ファイル",
  "invite.upload.uploading": "アップロード中...",
  "invite.upload.analyzing": "文書を確認中...",
  "invite.upload.success": "正常にアップロードされました",
  "invite.upload.next": "次の文書",
  "invite.upload.finish": "すべてを確認",
  "invite.upload.skip": "今はスキップ",
  "invite.upload.progress": "進捗",
  "invite.complete.title": "完了しました！",
  "invite.complete.subtitle": "お客様の文書が正常に送信されました。",
  "invite.complete.message": "すべての文書を受け取りました。間もなくご連絡いたします。",
  "invite.complete.summary": "送信された文書",
  "invite.complete.securityNote": "お客様の文書は安全に保存され、権限を持つ担当者のみがアクセスできます。",
  "invite.chat.title": "担当者とチャット",
  "invite.chat.placeholder": "メッセージを入力...",
  "invite.chat.empty": "まだメッセージがありません。会話を始めましょう。",
  "invite.chat.sent": "メッセージが送信されました。",
  "invite.chat.willRespond": "できるだけ早くお返事いたします。",
  "invite.chat.sending": "送信中...",
  "invite.error.title": "無効または期限切れのリンク",
  "invite.error.message": "この招待リンクはもう有効ではありません。送信者に新しいリンクをリクエストしてください。",
  "common.loading": "読み込み中...",
  "common.save": "保存",
  "common.cancel": "キャンセル",
  "common.delete": "削除",
  "common.edit": "編集",
  "common.create": "作成",
  "common.close": "閉じる",
  "common.dismiss": "閉じる",
  "common.confirm": "確認",
  "common.back": "戻る",
  "common.next": "次へ",
  "common.previous": "前へ",
  "common.of": "/",
  "common.search": "検索",
  "common.filter": "フィルター",
  "common.sort": "並べ替え",
  "common.viewAll": "すべて表示",
  "common.refresh": "更新",
  "common.retry": "再試行",
  "common.yes": "はい",
  "common.no": "いいえ",
  "common.or": "または",
  "common.and": "および",
  "common.optional": "任意",
  "common.required": "必須",
  "status.draft": "下書き",
  "status.active": "進行中",
  "status.pending": "保留中",
  "status.pending_documents": "文書待ち",
  "status.pending_signature": "署名待ち",
  "status.on_hold": "保留",
  "status.closed": "完了",
  "status.cancelled": "キャンセル済み",
  "error.generic": "問題が発生しました。もう一度お試しください。",
  "error.network": "ネットワークエラー。接続を確認してください。",
  "error.unauthorized": "この操作を実行する権限がありません。",
  "error.notFound": "リクエストされたリソースが見つかりません。",
  "error.validation": "入力を確認してもう一度お試しください。",
  "error.serverError": "サーバーエラー。後でもう一度お試しください。",
  "success.saved": "変更が正常に保存されました。",
  "success.created": "正常に作成されました。",
  "success.deleted": "正常に削除されました。",
  "success.sent": "正常に送信されました。",
  "success.uploaded": "正常にアップロードされました。",
  "time.justNow": "たった今",
  "time.minutesAgo": "{count}分前",
  "time.hoursAgo": "{count}時間前",
  "time.daysAgo": "{count}日前",
  "time.today": "今日",
  "time.yesterday": "昨日",
  "dealRoom.notFound": "取引が見つかりません",
  "dealRoom.loading": "取引を読み込み中...",
  "dealRoom.conversation.title": "取引の会話",
  "dealRoom.conversation.you": "あなた",
  "dealRoom.conversation.client": "クライアント",
  "dealRoom.messages.hideOriginal": "原文を非表示",
  "dealRoom.messages.original": "原文（{language}）",
  "dealRoom.messages.disabled": "この取引ステータスではメッセージが無効です",
  "dealRoom.messages.aiSuggest": "AI提案の返信",
  "dealRoom.documents.title": "文書",
  "dealRoom.documents.uploadDisabled": "アップロード無効",
  "dealRoom.documents.pendingAnalysis": "分析待ち",
  "dealRoom.documents.uploadFirst": "最初の文書をアップロード",
  "dealRoom.documents.uploadHelp": "AI分析のためにこの取引に文書をアップロード",
  "dealRoom.documents.uploadDisabledHelp": "この取引ステータスでは文書のアップロードが無効です",
  "dealRoom.documents.analyzeWithAI": "AIで分析",
  "dealRoom.documents.notAnalyzed": "まだ分析されていません",
  "dealRoom.documents.notAnalyzedHelp": "AI分析を実行して文書タイプ、フィールドを抽出し、インサイトを取得",
  "dealRoom.documents.analyzeDocument": "文書を分析",
  "dealRoom.documents.extractedFields": "抽出されたフィールド",
  "dealRoom.documents.issuesDetected": "検出された問題",
  "dealRoom.documents.preview": "プレビュー",
  "dealRoom.documents.uploaded": "アップロード済み",
  "dealRoom.documents.deleteConfirm": "この文書を削除してもよろしいですか？",
  "dealRoom.onHold.message": "この取引は保留中です。文書のアップロードが無効です。調整のためにメッセージを送信することはできます。",
  "dealRoom.pendingSignature.message": "契約書は署名準備完了です。契約書が署名されるか元に戻されるまで、文書のアップロードが無効です。",
  "dealRoom.status.current": "現在",
  "dealRoom.status.finalWarning": "これは最終状態です。この操作後、取引を再開することはできません。",
  "dealRoom.contract.purchaseAgreement": "売買契約書",
  "dealRoom.contract.purchaseAgreementDesc": "標準売買契約書",
  "dealRoom.contract.noContract": "まだ契約書なし",
  "dealRoom.contract.noContractDesc": "取引詳細と文書に基づいてAI搭載契約書ドラフトを生成します。",
  "dealRoom.contract.notAvailable": "{status}取引では契約書生成を利用できません。",
  "dealRoom.contract.locked": "署名待ちのため契約書生成がロックされています。",
  "dealRoom.contract.requiresPlan": "Business Starterプランが必要です",
  "dealRoom.toast.dealUpdated": "取引が更新されました",
  "dealRoom.toast.statusChanged": "取引ステータスが{status}に変更されました",
  "dealRoom.toast.statusFailed": "ステータスの変更に失敗しました",
  "dealRoom.toast.contractGenerated": "契約書ドラフトが正常に生成されました",
  "dealRoom.toast.contractCopied": "{language}契約書がクリップボードにコピーされました",
  "dealRoom.toast.messageFailed": "メッセージの送信に失敗しました",
  "dealRoom.toast.suggestionFailed": "提案の生成に失敗しました",
  "dealRoom.toast.documentUploaded": "文書がアップロードされました",
  "dealRoom.toast.uploadFailed": "アップロードに失敗しました",
  "dealRoom.toast.analysisComplete": "AI文書分析が完了しました",
  "dealRoom.toast.analysisFailed": "AI分析に失敗しました",
  "dealRoom.toast.documentDeleted": "文書が削除されました",
  "dealRoom.toast.deleteFailed": "削除に失敗しました",
  "dealRoom.details.created": "作成日",
  "dealRoom.details.addNotes": "取引メモを追加...",
  "onboarding.brand": "PocketFiler",
  "onboarding.skip": "今はスキップ",
  "onboarding.badge": "AI搭載セットアップ",
  "onboarding.welcome": "ようこそ、{name}さん！",
  "onboarding.welcomeGeneric": "ようこそ！",
  "onboarding.subtitle": "PocketFilerワークスペースを設定しましょう。AIコンシェルジュにビジネスについて教えてください。すべてを設定いたします。",
  "onboarding.step1": "ビジネスとニーズを説明",
  "onboarding.step2": "AIが設定を提案",
  "onboarding.step3": "取引管理を開始",
  "onboarding.concierge.title": "AIコンシェルジュ",
  "onboarding.toast.officeCreated": "バーチャルオフィスが作成されました！",
  "auth.signup.accountType": "アカウントタイプ",
  "auth.signup.passwordTooShort": "パスワードは8文字以上である必要があります",
  "auth.signup.passwordsDoNotMatch": "パスワードが一致しません",
  "auth.signup.success": "アカウントが正常に作成されました！",
  "captions.connecting": "接続中...",
  "captions.disable": "字幕を無効化",
  "captions.enable": "字幕を有効化",
  "captions.error.connect": "字幕サービスへの接続に失敗しました",
  "captions.error.toggle": "字幕の切り替えに失敗しました",
  "captions.language": "字幕言語",
  "captions.live": "ライブ",
  "captions.off": "字幕オフ",
  "captions.on": "字幕オン",
  "captions.original": "原文",
  "captions.translated": "翻訳済み",
  "captions.translating": "翻訳中...",
  "clients.joined.empty.desc": "まだどの組織にも参加していません。PocketFilerワークスペースへの招待を依頼してください。",
  "clients.joined.empty.title": "参加組織なし",
  "clients.nav.joinedOrgs": "参加組織",
  "clients.nav.myClients": "私のクライアント",
  "clients.table.joinedDate": "参加日",
  "clients.table.organization": "組織",
  "common.backToHome": "ホームに戻る",
  "common.deleteConfirmDesc": "この操作は元に戻せません。アイテムが完全に削除され、サーバーからデータが除去されます。",
  "common.deleteConfirmTitle": "本当によろしいですか？",
  "common.noResults": "結果が見つかりません",
  "connect.createAccount": "無料アカウント作成",
  "connect.dealCreated": "取引を正常に作成しました",
  "connect.error.invalid": "無効な接続リンク",
  "connect.error.invalidDesc": "この接続リンクは無効または期限切れです。",
  "connect.error.server": "問題が発生しました",
  "connect.error.serverDesc": "後でもう一度お試しください。",
  "connect.infoUnauth": "この方はPocketFilerを使用して多言語取引と書類を安全に管理しています。",
  "connect.joinOffice": "バーチャルオフィスに参加",
  "connect.loggedInAs": "ログイン中",
  "connect.login": "ログイン",
  "connect.startDeal": "取引を開始",
  "connect.titleAuth": "接続先",
  "connect.titleUnauth": "接続",
  "connect.typeOrg": "組織",
  "connect.typePerson": "個人",
  "contacts.actions.call": "電話",
  "contacts.actions.email": "メール",
  "contacts.actions.message": "アプリ内メッセージ送信",
  "contacts.actions.noEmail": "メールアドレスなし",
  "contacts.actions.noPhone": "電話番号なし",
  "contacts.actions.sms": "メッセージ",
  "contacts.actions.title": "連絡先 {name}",
  "contacts.actions.whatsapp": "WhatsApp",
  "contacts.dialog.name": "連絡先名",
  "contacts.dialog.title": "新しい連絡先を追加",
  "contacts.empty.desc": "最初の連絡先を追加して始めましょう。",
  "contacts.empty.title": "連絡先がありません",
  "contacts.invite": "連絡先を追加",
  "contacts.invite.customNotePlaceholder": "この連絡先に関する特記事項...",
  "contacts.invite.nameLabel": "連絡先名",
  "contacts.invite.shareLink": "このリンクをメール、SMS、または直接連絡先と共有してください",
  "contacts.invite.step1Desc": "連絡先情報を入力",
  "contacts.invite.step1Title": "新しい連絡先を追加",
  "contacts.subtitle": "連絡先と招待を管理",
  "contacts.table.contact": "連絡先",
  "contacts.title": "連絡先",
  "contacts.toast.deleted": "連絡先を削除しました",
  "contacts.toast.invited": "連絡先を追加しました：{name}",
  "contacts.toast.linkCopied": "リンクをクリップボードにコピーしました",
  "dashboard.quickActions.inviteContact": "連絡先を追加",
  "dashboard.recentContacts.empty": "まだ連絡先がありません。最初の連絡先を招待して始めましょう。",
  "dashboard.recentContacts.title": "最近の連絡先",
  "dashboard.recentContacts.viewAll": "すべて表示",
  "dashboard.stats.totalContacts": "連絡先総数",
  "dealRoom.contract.analysisWarning": "一部の書類がまだ分析されていません。AI分析により契約の精度が向上します。",
  "dealRoom.conversation.colleague": "同僚",
  "dealRoom.details.clients": "クライアント",
  "dealRoom.documents.previewNotAvailable": "プレビューは利用できません。ダウンロード中...",
  "dealRoom.incomingCall.accept": "応答",
  "dealRoom.incomingCall.decline": "拒否",
  "dealRoom.incomingCall.inProgress": "通話中",
  "dealRoom.incomingCall.started": "{name}が通話を開始しました",
  "dealRoom.messages.connecting": "チャットに接続中...",
  "dealRoom.messages.connectionError": "会話に接続できません。",
  "dealRoom.pendingSignature.loading": "署名状況を読み込み中...",
  "dealRoom.pendingSignature.signedWaitingOthers": "正常に署名されました。他の参加者を待機中です。",
  "dealRoom.readOnly.completedMessage": "この取引は正常に完了しました。取引ルームは参照と監査目的で読み取り専用になっています。",
  "dealRoom.signature.signed": "署名済み",
  "dealRoom.signature.signedByYou": "あなたが署名済み",
  "dealRoom.signature.success": "契約に正常に署名しました！",
  "dealRoom.signaturesList.clients": "クライアント",
  "dealRoom.signaturesList.dealOwner": "取引オーナー",
  "dealRoom.signaturesList.pending": "保留中",
  "dealRoom.signaturesList.signedOn": "署名日",
  "dealRoom.signaturesList.title": "署名",
  "dealRoom.signaturesList.viewSignatures": "署名を表示",
  "dealRoom.signedByAll.addPayment": "支払いを追加",
  "dealRoom.signedByAll.message": "すべての参加者が署名しました。支払いに進んでください。",
  "dealRoom.timeline.createdBy": "{name}による作成",
  "deals.tabs.all": "すべての取引",
  "deals.tabs.my": "私の取引",
  "deals.validation.clientRequired": "少なくとも1つのクライアントを選択してください",
  "deals.validation.notesLength": "ノートは200文字以下である必要があります",
  "deals.validation.titleLength": "タイトルは100文字以下である必要があります",
  "deals.validation.titleRequired": "取引タイトルは必須です",
  "documents.readAloud.analyzeFirst": "音声読み上げするには、まずこの文書を分析してください。",
  "documents.readAloud.error": "音声読み上げに失敗しました",
  "documents.readAloud.title": "音声読み上げ",
  "landing.cta.secondary": "サンプル取引ルームを見る",
  "landing.hero.trust": "無料プラン。クレジットカード不要。11言語対応。",
  "landing.socialProof": "40カ国、500社以上に信頼されています",
  "landing.useCases.personal.desc": "車両、設備、不動産などの重要な単発取引を明確な記録、AI契約、安全な書類共有リンクで完了できます。",
  "landing.useCases.personal.title": "高額個人取引",
  "landing.useCases.professional.desc": "AIアシスタント付きでクライアントに書類アップロードを依頼し、セキュアな仮想オフィスですべてのやり取りを追跡、バイリンガル電子契約の生成まで、すべてひとつのワークスペースで行えます。",
  "landing.useCases.professional.subtitle": "保険、不動産、融資",
  "landing.useCases.professional.title": "プロフェッショナルサービス",
  "livekit.call": "通話",
  "livekit.connecting": "接続中...",
  "livekit.error.connect": "通話接続に失敗しました。再度お試しください。",
  "livekit.error.connection": "接続エラー。ネットワークを確認して再度お試しください。",
  "livekit.error.permission": "この通話に参加する権限がありません。",
  "livekit.hint": "アプリを切り替える代わりに、この取引内で会話してください。",
  "livekit.inCall": "通話中",
  "livekit.joinCall": "通話に参加",
  "livekit.leaveCall": "通話終了",
  "livekit.participant": "参加者",
  "livekit.participants": "参加者",
  "messages.readAloud.error": "音声読み上げに失敗しました",
  "messages.readAloud.title": "音声読み上げ",
  "nav.companyProfile": "会社概要",
  "nav.contacts": "連絡先",
  "nav.directory": "ディレクトリ",
  "nav.products": "商品",
  "offices.card.contacts": "{count}件の連絡先",
  "pwa.banner.install": "インストール",
  "pwa.banner.subtitle": "より高速なアクセス、オフライン対応",
  "pwa.banner.title": "PocketFilerアプリを入手",
  "pwa.firefox.hint": "Firefoxでは、アドレスバーのインストールアイコン（⊕）を探して、このアプリをデスクトップに追加してください。",
  "pwa.installApp": "アプリをインストール",
  "pwa.installed": "アプリを正常にインストールしました！",
  "pwa.ios.description": "最高のエクスペリエンスのためにPocketFilerをホーム画面に追加してください：",
  "pwa.ios.gotIt": "了解",
  "pwa.ios.inToolbar": "をタップ",
  "pwa.ios.inTopRight": "をタップ",
  "pwa.ios.shareButton": "共有ボタン",
  "pwa.ios.step1": "ブラウザツールバーの",
  "pwa.ios.step2": "下にスクロールして以下をタップ",
  "pwa.ios.step3": "右上の",
  "pwa.ios.title": "PocketFilerをインストール",
  "pwa.iosHint": "共有アイコンをタップし、「ホーム画面に追加」でPocketFilerをインストールしてください。",
  "pwa.opera.chromeHint": "このページを開き、アドレスバーのインストールアイコンをクリック",
  "pwa.opera.desktopNotSupported": "Opera デスクトップはPWAインストールに対応していません。PocketFilerをアプリとしてインストールするには、Google ChromeまたはMicrosoft Edgeで開いてください。",
  "pwa.opera.edgeHint": "このページを開き、アドレスバーのインストールアイコン（⊕）をクリック",
  "pwa.opera.mobileAddPage": "ページを追加",
  "pwa.opera.mobileDescription": "Operaの下部の+アイコンをタップ、または以下のメニューを使用：",
  "pwa.opera.mobileHomeScreen": "ホーム画面",
  "pwa.opera.mobileStep1": "Operaの下部バーの",
  "pwa.opera.mobileStep1b": "プラス（+）アイコンをタップ",
  "pwa.opera.mobileStep2": "または以下をタップ",
  "pwa.opera.mobileTitle": "OperaでPocketFilerをインストール",
  "pwa.opera.recommendedBrowsers": "代わりに使用：",
  "pwa.opera.title": "Operaでは利用できません",
  "qr.clickToExpand": "クリックして全画面表示",
  "qr.copied": "コピーしました！",
  "qr.copyLink": "リンクをコピー",
  "qr.description": "このコードをクライアントやパートナーに見せてください。スキャンすると、あなたと繋がって数秒で取引を開始できます。",
  "qr.download": "ダウンロード",
  "qr.generate": "QRコード生成",
  "qr.linkCopied": "リンクをクリップボードにコピーしました",
  "qr.primaryLanguage": "主要言語",
  "qr.regenerate": "リセット",
  "qr.regenerated": "QRコードを再生成しました。古いリンクは無効になりました。",
  "qr.scanInstructions": "PocketFilerまたは任意のQRスキャナーでこのQRをスキャンして接続してください。",
  "qr.scanToConnect": "スキャンして接続",
  "qr.share": "共有",
  "qr.title": "PocketFiler QRを共有",
  "qr.yourLink": "接続リンク：",
  "recording.completed": "録画完了",
  "recording.confirmDelete": "この録画を削除しますか？",
  "recording.delete": "削除",
  "recording.deleted": "録画を削除しました",
  "recording.download": "ダウンロード",
  "recording.error.delete": "録画の削除に失敗しました",
  "recording.error.noCall": "アクティブな通話がありません。まず通話に参加してください。",
  "recording.error.start": "録画の開始に失敗しました",
  "recording.error.stop": "録画の停止に失敗しました",
  "recording.failed": "録画に失敗しました",
  "recording.noRecordings": "録画はまだありません",
  "recording.play": "再生",
  "recording.playback": "録画再生",
  "recording.processing": "処理中...",
  "recording.start": "録画",
  "recording.started": "録画を開始しました",
  "recording.stop": "停止",
  "recording.stopped": "録画を停止しました。処理中...",
  "recording.viewRecordings": "録画を表示",
  "schedule.button": "スケジュール",
  "schedule.cancel": "キャンセル",
  "schedule.chooseDateTime": "日時を選択してください",
  "schedule.create": "スケジュール",
  "schedule.created": "スケジュール済み",
  "schedule.dateTime": "日時",
  "schedule.description": "日時を選択してください。時間になったら通話に参加できます。",
  "schedule.title": "通話または録画をスケジュール",
  "schedule.type": "タイプ",
  "schedule.typeCall": "通話",
  "schedule.typeRecording": "録画",
  "schedule.upcoming": "予定されたスケジュール",
  "settings.profile.accountType": "アカウントタイプ",
  "settings.profile.accountTypeHelp": "あなたに最適なタイプを選択してください",
  "settings.tabs.sharing": "QR共有",
  "support.askAI": "AIに質問",
  "support.availableTimes": "利用可能な時間",
  "support.booked": "通話を正常に予約しました！",
  "support.bookingConfirmed": "通話を{time}に予約しました。通話リンクが記載された確認メールをお送りします。他にお手伝いできることはありますか？",
  "support.bookingError": "枠の予約に失敗しました。再度お試しください。",
  "support.clearChat": "チャットをクリア",
  "support.error": "メッセージ送信に失敗しました。再度お試しください。",
  "support.inYourTime": "現地時間",
  "support.inputPlaceholder": "質問を入力してください...",
  "support.openChat": "AIサポートを開く",
  "support.scheduleCall": "サポート通話を予約",
  "support.scheduleTitle": "サポート通話を予約",
  "support.slotsError": "利用可能な時間の読み込みに失敗しました。",
  "support.subtitle": "PocketFilerについて何でもお聞きください",
  "support.title": "AIサポート",
  "support.welcome": "こんにちは！PocketFiler AIアシスタントです。以下についてサポートできます：\\n\\n- 取引の作成と管理\\n- 署名用書類の送信\\n- QR接続機能の使用\\n- クライアントの招待\\n- PocketFilerに関するその他のご質問\\n\\n今日はどのようにお手伝いできますか？",
  "support.yourTimezone": "あなたのタイムゾーン",
  "validation.emailInvalid": "無効なメール形式です",
  "validation.emailRequired": "メールアドレスは必須です",
  "validation.nameRequired": "名前は必須です",
  "validation.nameTooLong": "名前は50文字未満である必要があります",
  "validation.noteTooLong": "ノートは200文字未満である必要があります",
  "validation.phoneInvalid": "無効な電話番号です（10-15桁）",
  "validation.phoneRequired": "電話番号は必須です",
  "deals.column.cancelled": "キャンセル済み",
  "deals.column.completed": "完了",
  "deals.column.disputed": "異議あり",
  "deals.column.escrow_funded": "エスクロー入金済み",
  "deals.column.on_hold": "保留中",
  "deals.column.pending_documents": "書類待ち",
  "deals.column.pending_payment": "支払い待ち",
  "deals.column.pending_signature": "署名待ち",
  "deals.column.release_requested": "リリース要求済み",
  "dashboard.actions.addClient": "クライアントを追加",
  "dashboard.actions.all": "すべて",
  "dashboard.actions.createContract": "契約書を作成",
  "dashboard.actions.createInvoice": "請求書を作成",
  "dashboard.actions.customize": "カスタマイズ",
  "dashboard.actions.newDeal": "新規案件",
  "dashboard.actions.scheduleMeeting": "会議をスケジュール",
  "dashboard.actions.uploadDocument": "ドキュメントをアップロード",
  "dashboard.actions.viewAll": "すべて表示",
  "dashboard.briefing.default": "現在、緊急の案件はありません。ワークスペースは良好な状態です。",
  "dashboard.briefing.title": "デイリーブリーフィング",
  "dashboard.empty.activity": "最近のアクティビティはありません。",
  "dashboard.empty.deals": "案件がまだありません。最初の案件を作成してパイプラインを確認しましょう。",
  "dashboard.empty.documents": "すべてのドキュメントは最新の状態です。",
  "dashboard.empty.meetings": "予定されている会議はありません。",
  "dashboard.empty.tasks": "未完了のタスクはありません。",
  "dashboard.greeting.afternoon": "こんにちは",
  "dashboard.greeting.evening": "こんばんは",
  "dashboard.greeting.morning": "おはようございます",
  "dashboard.greeting.subtitle": "ワークスペース全体の状況をお知らせします。",
  "dashboard.stats.documents": "ドキュメント",
  "dashboard.stats.invoicesDue": "期限の請求書",
  "dashboard.stats.meetingsComing": "予定されている会議",
  "dashboard.stats.tasksDue": "期限のタスク",
  "dashboard.stats.unreadMessages": "未読メッセージ",
  "dashboard.widgets.dealPipeline": "案件パイプライン",
  "dashboard.widgets.documentsAttention": "要確認ドキュメント",
  "dashboard.widgets.gettingStarted": "はじめに",
  "dashboard.widgets.quickActions": "クイックアクション",
  "dashboard.widgets.recentActivity": "最近のアクティビティ",
  "dashboard.widgets.tasks": "タスク",
  "dashboard.widgets.upcomingMeetings": "今後の会議",
  "dashboard.steps.createDeal": "最初の取引を作成",
  "dashboard.steps.addClient": "クライアントを追加",
  "dashboard.steps.uploadDocument": "ドキュメントをアップロード",
  "dashboard.steps.scheduleMeeting": "会議をスケジュール",
  "dashboard.steps.createInvoice": "請求書を作成",
  "dashboard.steps.addLogo": "ロゴを追加",
  "dashboard.steps.complete": "完了",
  "dashboard.time.overdue": "期限超過",
  "dashboard.time.today": "今日",
  "dashboard.time.tomorrow": "明日",
  "dashboard.time.noDate": "日付なし",
  "dashboard.docReason.sent": "送信済み、返答待ち",
  "dashboard.docReason.notAnalyzed": "未分析",
  "dashboard.docReason.draft": "下書き、未確定",
  "dashboard.docReason.needsReview": "レビューが必要",
  "docViewer.notFound": "文書が見つかりません",
  "docViewer.previewUnavailable": "このファイル形式のプレビューはご利用いただけません",
  "docViewer.aiAnalysis": "AI Analysis",
  "docViewer.documentType": "文書種別",
  "docViewer.summary": "概要",
  "docViewer.extractedFields": "抽出されたフィールド",
  "docViewer.issues": "問題",
  "docViewer.tags": "タグ",
  "docViewer.noPreviousVersions": "以前のバージョンはありません",
  "docViewer.noActivity": "アクティビティはまだありません",
  "auth.forgotPassword.title": "パスワードをリセット",
  "guestSign.loading": "契約書を読み込み中...",
  "guestSign.unableToLoad": "契約書を読み込めません",
  "guestSign.signed": "契約書に署名済み",
  "guestSign.createOwn": "独自の契約書を作成・管理されますか？",
  "guestSign.secureSign": "安全な署名",
  "meeting.ended": "この会議は終了しました",
  "meeting.cancelled": "会議はキャンセルされました",
  "meeting.notFound": "会議が見つかりません",
  "meeting.joiningAs": "参加名義",
  "meeting.yourName": "お名前 *",
  "meeting.emailOptional": "メールアドレス（任意）",
  "notFound.title": "ページが見つかりません",
  "notFound.dashboard": "Dashboard へ移動",
  "notFound.home": "ホーム",
  "auth.resetPassword.invalidLink": "無効なリンクです",
  "auth.resetPassword.title": "新しいパスワードを設定",
  "templates.category": "カテゴリ",
  "templates.legal": "法務",
  "templates.sales": "営業",
  "templates.services": "サービス",
  "templates.finance": "財務",
  "templates.library": "Template Library",
  "templates.libraryDesc": "ビジネスですぐに使える文書テンプレート",
  "templates.noDefault": "検索に一致するデフォルトテンプレートがありません。",
  "templates.noCustom": "カスタムテンプレートが見つかりません",
  "templates.delete": "テンプレートを削除",
  "templates.cancel": "キャンセル",
  "uploadRequest.notFound": "リクエストが見つかりません",
  "uploadRequest.error": "問題が発生しました",
  "uploadRequest.errorDesc": "後ほど再度お試しいただくか、このリクエストを送信した方にお問い合わせください。",
  "uploadRequest.uploaded": "文書がアップロードされました！",
  "uploadRequest.title": "文書アップロードリクエスト",
  "uploadRequest.fileTypes": "PDF、画像、Word文書 - 最大25MB",
  "verify.verifying": "メールアドレスを確認中...",
  "verify.success": "メールアドレスが確認されました！",
  "verify.signIn": "サインイン",
  "verify.alreadyVerified": "既に確認済みです",
  "verify.invalidLink": "無効なリンクです",
  "verify.backToLogin": "ログインに戻る",
  "documents.documents": "文書",
  "documents.allStatus": "全てのステータス",
  "documents.newFolder": "新しいフォルダ",
  "documents.clear": "クリア",
  "documents.noDocumentsYet": "まだ文書がありません",
  "documents.status": "ステータス",
  "documents.type": "タイプ",
  "documents.uploadedBy": "アップロード者",
  "documents.previewNotAvailable": "プレビューは利用できません",
  "documents.aiAnalysis": "AI分析",
  "documents.documentType": "文書タイプ",
  "documents.summary": "概要",
  "documents.extractedFields": "抽出フィールド",
  "documents.issues": "問題",
  "documents.notYetAnalyzed": "まだ分析されていません",
  "documents.details": "詳細",
  "documents.size": "サイズ",
  "documents.date": "日付",
  "documents.mimeType": "MIMEタイプ",
  "documents.noTags": "タグはありません",
  "documents.changeStatus": "ステータス変更",
  "documents.versionHistory": "バージョン履歴",
  "documents.noPreviousVersions": "以前のバージョンはありません",
  "documents.activityLog": "アクティビティログ",
  "documents.noActivityRecordedYet": "まだアクティビティが記録されていません",
  "documents.uploadDocuments": "文書をアップロード",
  "documents.dragAndDropFiles": "ファイルをドラッグ&ドロップするかクリックしてブラウズしてください。PDF、画像、Word文書に対応しています。",
  "documents.shareDocument": "文書を共有",
  "documents.done": "完了",
  "documents.emailOptional": "メールアドレス（任意）",
  "documents.leaveEmptyToJust": "リンクのみを生成する場合は空欄にしてください",
  "documents.messageOptional": "メッセージ（任意）",
  "documents.cancel": "キャンセル",
  "documents.requestDocuments": "文書をリクエスト",
  "documents.sendASecureUpload": "メール経由でクライアントにセキュアなアップロードリンクを送信します。",
  "documents.clientEmail": "クライアントメールアドレス *",
  "documents.clientName": "クライアント名",
  "documents.requestedDocuments": "リクエスト文書 *",
  "documents.renameFolder": "フォルダ名を変更",
  "documents.selectADestinationFolder": "宛先フォルダを選択してください。",
  "documents.deleteDocument": "文書を削除しますか？",
  "settings.individual": "個人",
  "settings.business": "法人",
  "settings.buyer": "買い手",
  "settings.seller": "売り手",
  "settings.chooseYourPreferredTheme": "お好みのテーマを選択してください",
  "settings.light": "ライト",
  "settings.dark": "ダーク",
  "settings.system": "システム",
  "settings.manufacturing": "製造業",
  "settings.insurance": "保険",
  "settings.realEstate": "不動産",
  "settings.automotive": "自動車",
  "settings.importexport": "輸出入",
  "settings.other": "その他",
  "settings.brandingWhitelabel": "ブランディング & ホワイトラベル",
  "settings.customizeThePocketfilerExperience": "クライアント向けのPocketFilerエクスペリエンスをカスタマイズします。",
  "settings.organizationLogo": "組織ロゴ",
  "settings.provideADirectLink": "透明PNGまたはSVGロゴへの直リンクを提供してください。",
  "settings.primaryThemeColor": "プライマリテーマカラー",
  "settings.selectAHexColor": "ブランドのプライマリアクセントを表すhexカラーコードを選択してください。",
  "settings.accentHoverColor": "アクセント / ホバーカラー",
  "settings.selectAHexColor1": "ホバー状態、ハイライト、アクセント要素のhexカラーを選択してください。",
  "settings.customDomain": "カスタムドメイン",
  "settings.ensureYouConfigureA": "pocketfiler.comを指すCNAMEレコードを設定してください。",
  "settings.cancellationScheduled": "解約予定",
  "settings.yourLastPaymentFailed": "前回のお支払いが失敗しました。アクセスを継続するために支払い方法を更新してください。",
  "settings.chooseYourPlan": "プランを選択",
  "settings.monthly": "月額",
  "settings.save20": "20％節約",
  "settings.current": "現在",
  "settings.popular": "人気",
  "settings.contactSales": "営業にお問い合わせ",
  "settings.googleCalendar": "Google Calendar",
  "settings.syncYourPocketfilerMeetings": "PocketFilerミーティングをGoogle Calendarと同期します",
  "settings.settingsPageErrorDebug": "設定ページエラー（デバッグ）",
  "invoices.createInvoice": "請求書を作成",
  "invoices.createANewInvoice": "クライアント向けの新しい請求書を作成",
  "invoices.selectClient": "クライアント選択",
  "invoices.dueDate": "支払期日",
  "invoices.clientName": "クライアント名",
  "invoices.clientEmail": "クライアントメールアドレス",
  "invoices.lineItems": "明細項目",
  "invoices.description": "説明",
  "invoices.qty": "数量",
  "invoices.price": "価格",
  "invoices.tax": "税率 %",
  "invoices.total": "合計",
  "invoices.subtotal": "小計:",
  "invoices.discount": "割引:",
  "invoices.tax1": "税額:",
  "invoices.total1": "合計:",
  "invoices.notesOptional": "備考（任意）",
  "invoices.invoices": "請求書",
  "invoices.manageAndTrackYour": "請求書の管理と追跡",
  "invoices.totalInvoiced": "請求総額",
  "invoices.paid": "支払済み",
  "invoices.outstanding": "未払い",
  "invoices.totalInvoices": "請求書総数",
  "invoices.allInvoices": "全ての請求書",
  "invoices.myInvoices": "マイ請求書",
  "invoices.receivedInvoices": "受信した請求書",
  "invoices.noInvoicesYet": "請求書はまだありません",
  "meetings.join": "参加",
  "meetings.end": "終了",
  "meetings.meetingTitle": "ミーティングタイトル",
  "meetings.date": "日付",
  "meetings.time": "時間",
  "meetings.duration": "継続時間",
  "meetings.repeat": "繰り返し",
  "meetings.doesNotRepeat": "繰り返しなし",
  "meetings.weekly": "毎週",
  "meetings.every2Weeks": "2週間ごと",
  "meetings.monthly": "毎月",
  "meetings.invitePeopleOptional": "招待する人（任意）",
  "meetings.cancel": "キャンセル",
  "meetings.meetings": "ミーティング",
  "companyprofile.companyProfile": "企業プロフィール",
  "companyprofile.manageYourBusinessProfile": "ビジネスプロフィールとチームを管理する",
  "companyprofile.publicProfile": "公開プロフィール",
  "companyprofile.basicInformation": "基本情報",
  "companyprofile.essentialDetailsAboutYour": "企業に関する重要な詳細情報",
  "companyprofile.companyName": "企業名",
  "companyprofile.tagline": "タグライン",
  "companyprofile.industry": "業界",
  "companyprofile.companyType": "企業タイプ",
  "companyprofile.description": "説明",
  "companyprofile.companyDetails": "企業詳細",
  "companyprofile.additionalInformationAboutYour": "ビジネスに関する追加情報",
  "companyprofile.yearEstablished": "設立年",
  "companyprofile.numberOfEmployees": "従業員数",
  "companyprofile.certifications": "認証",
  "companyprofile.enterCertificationsSeparatedBy": "認証をカンマ区切りで入力してください",
  "companyprofile.languagesSpoken": "対応言語",
  "companyprofile.shippingRegions": "配送地域",
  "companyprofile.contactInformation": "連絡先情報",
  "companyprofile.howPotentialPartnersCan": "潜在的なパートナーがあなたに連絡する方法",
  "companyprofile.website": "ウェブサイト",
  "companyprofile.email": "メールアドレス",
  "companyprofile.phone": "電話番号",
  "companyprofile.country": "国",
  "companyprofile.city": "都市",
  "companyprofile.address": "住所",
  "companyprofile.teamMembers": "チームメンバー",
  "companyprofile.manageUsersWithinYour": "組織内のユーザーを管理する",
  "companyprofile.role": "役割",
  "companyprofile.admin": "管理者",
  "companyprofile.member": "メンバー",
  "companyprofile.viewer": "閲覧者",
  "companyprofile.titleOptional": "役職（任意）",
  "companyprofile.name": "名前",
  "companyprofile.title": "役職",
  "companyprofile.status": "ステータス",
  "companyprofile.actions": "アクション",
  "companyprofile.owner": "オーナー",
  "companyprofile.copyInviteLink": "招待リンクをコピー",
  "companyprofile.removeMember": "メンバーを削除",
  "companyprofile.removeTeamMember": "チームメンバーを削除",
  "companyprofile.cancel": "キャンセル",
  "products.productsServices": "製品・サービス",
  "products.description": "説明",
  "products.pricing": "価格設定",
  "products.price": "価格",
  "products.unit": "単位",
  "products.details": "詳細",
  "products.minOrderQty": "最小注文数量",
  "products.leadTime": "リードタイム",
  "products.category": "カテゴリー",
  "products.currency": "通貨",
  "products.leadTimeDays": "リードタイム（日数）",
  "products.active": "有効",
  "products.showInCatalog": "カタログに表示",
  "products.cancel": "キャンセル",
  "developersettings.reveal": "表示",
  "developersettings.copy": "コピー",
  "developersettings.hide": "非表示",
  "developersettings.securityWarning": "セキュリティ警告",
  "developersettings.neverShareThisKey": "このキーを公開またはクライアントサイドコードで共有しないでください",
  "developersettings.anyoneWithThisKey": "このキーを持つ人は誰でもあなたのデータを読み取り、変更できます",
  "developersettings.ifCompromisedRevokeImmediately": "漏洩した場合は、直ちに取り消して新しいキーを生成してください",
  "developersettings.iUnderstandAndAccept": "このキーのセキュリティに関する責任を理解し、受け入れます",
  "developersettings.cancel": "キャンセル",
  "developersettings.revealKey": "キーを表示",
  "developersettings.accessDenied": "アクセス拒否",
  "developersettings.onlyBusinessAccountsHave": "ビジネスアカウントのみが開発者設定にアクセスできます",
  "developersettings.developerOverview": "開発者概要",
  "developersettings.manageYourApiKeys": "サードパーティ統合のためのAPIキーとWebhookエンドポイントを管理する",
  "developersettings.secretApiKeys": "秘密APIキー",
  "developersettings.interactiveApiDocumentationRarr": "インタラクティブAPIドキュメント &rarr;",
  "developersettings.name": "名前",
  "developersettings.key": "キー",
  "developersettings.createdAt": "作成日時",
  "developersettings.status": "ステータス",
  "developersettings.actions": "アクション",
  "developersettings.webhookEndpoints": "Webhookエンドポイント",
  "developersettings.url": "URL",
  "developersettings.events": "イベント",
  "developersettings.description": "説明",
  "developersettings.done": "完了",
  "developersettings.addWebhookEndpoint": "Webhookエンドポイントを追加",
  "developersettings.payloadUrl": "ペイロードURL",
  "developersettings.eventsToSend": "送信するイベント",
  "developersettings.sendMeEverything": "すべて送信 (*)",
  "developersettings.dealStatusChangedDealstatuschanged": "案件ステータス変更 (deal.status_changed)",
  "developersettings.documentUploadedDocumentuploaded": "ドキュメントアップロード (document.uploaded)",
  "developersettings.descriptionOptional": "説明（任意）",
  "analytics.noDataAvailableFor": "この期間のデータはありません。",
  "analytics.noDealsFound": "案件が見つかりません。",
  "analytics.noClientDataAvailable": "この期間のクライアントデータはありません。",
  "analytics.client": "クライアント",
  "analytics.invoices": "請求書",
  "analytics.revenue": "売上",
  "analytics.totalPipeline": "総パイプライン",
  "analytics.noRecentActivityFor": "この期間の最近のアクティビティはありません。",
  "analytics.pipelineOverview": "パイプライン概要",
  "analytics.goToDeals": "案件へ移動",
  "analytics.analyticsDashboard": "分析ダッシュボード",
  "analytics.trackYourBusinessPerformance": "ビジネスパフォーマンスと洞察を追跡",
  "analytics.last7Days": "過去7日間",
  "analytics.last30Days": "過去30日間",
  "analytics.last90Days": "過去90日間",
  "analytics.lastYear": "昨年",
  "analytics.overview": "概要",
  "analytics.myPerformance": "マイパフォーマンス",
  "analytics.currentDealsByStatus": "ステータス別現在の案件",
  "analytics.revenueTrendsOverLast": "過去6ヶ月間の売上トレンド",
  "analytics.accountsGeneratingTheMost": "最も多くの売上を生み出しているアカウント",
  "analytics.currentCashFlowOverview": "現在のキャッシュフロー概要",
  "analytics.latestBusinessActivitiesAnd": "最新のビジネスアクティビティと更新",
  "compliance.complianceCenter": "コンプライアンスセンター",
  "compliance.hsCodesTariffsSanctions": "HSコード、関税、制裁スクリーニング、輸出規制",
  "compliance.hsCodeClassification": "HSコード分類",
  "compliance.productDescription": "製品説明",
  "compliance.tariffCalculator": "関税計算機",
  "compliance.estimateImportDutiesBased": "HSコードと貿易ルートに基づいて輸入関税を見積もります。",
  "compliance.hsCode": "HSコード",
  "compliance.declaredValueUsd": "申告価値 (USD)",
  "compliance.originCountry": "原産国",
  "compliance.destinationCountry": "仕向国",
  "compliance.dutyRate": "関税率:",
  "compliance.totalRate": "総税率:",
  "compliance.estDuty": "推定関税:",
  "compliance.totalEstCost": "推定総費用:",
  "compliance.tradeAgreements": "貿易協定:",
  "compliance.sanctionsScreening": "制裁スクリーニング",
  "compliance.screenEntitiesAgainstOfac": "OFAC SDNリストと国別制裁に対してエンティティをスクリーニングします。",
  "compliance.entityName": "エンティティ名",
  "compliance.type": "タイプ",
  "compliance.company": "企業",
  "compliance.individual": "個人",
  "compliance.vessel": "船舶",
  "compliance.countryOptional": "国（任意）",
  "compliance.usSanctionedCountries": "米国制裁対象国",
  "compliance.exportControlCheck": "輸出規制チェック",
  "compliance.aipoweredEaritarClassificationGuidance": "AI搭載EAR/ITAR分類ガイダンス。法的助言ではありません。",
  "compliance.producttechnologyDescription": "製品/技術説明",
  "compliance.hsCodeOptional": "HSコード（任意）",
  "compliance.endUseOptional": "最終用途（任意）",
  "compliance.licenseRequired": "ライセンス必要",
  "compliance.recommendations": "推奨事項:",
  "compliance.complianceHistory": "コンプライアンス履歴",
  "compliance.recentComplianceChecksFor": "組織の最近のコンプライアンスチェック。",
  "compliance.noComplianceChecksYet": "コンプライアンスチェックはまだありません。上記で最初のチェックを実行してください。",
  "intelligence.marketIntelligence": "マーケットインテリジェンス",
  "intelligence.anonymizedTradeDataAnd": "PocketFilerプラットフォームからの匿名化された貿易データとベンチマーク",
  "intelligence.demandByCategory": "カテゴリ別需要",
  "intelligence.whatBuyersAreSourcing": "プラットフォームでバイヤーが調達している商品（過去90日間）",
  "intelligence.noDemandDataYet": "需要データはまだありません。RFQがプラットフォーム上で作成されるとデータが蓄積されます。",
  "intelligence.byIndustry": "業界別",
  "intelligence.noSupplierDataYet": "サプライヤーデータはまだありません。",
  "intelligence.byCountry": "国別",
  "intelligence.byType": "タイプ別",
  "intelligence.byVerification": "認証別",
  "intelligence.noDataYet": "データはまだありません。",
  "intelligence.yourPerformanceVsPlatform": "プラットフォーム対あなたのパフォーマンス",
  "intelligence.seeHowYouStack": "プラットフォーム平均に対するあなたの立ち位置を確認",
  "intelligence.completeSomeDealsTo": "ベンチマークを確認するには案件を完了してください。",
  "virtualoffices.virtualOffices": "バーチャルオフィス",
  "virtualoffices.manageYourBrandedWorkspaces": "ブランド化されたワークスペースを管理",
  "virtualoffices.officeName": "オフィス名",
  "virtualoffices.industry": "業界",
  "virtualoffices.languagesServed": "対応言語",
  "virtualoffices.descriptionOptional": "説明（任意）",
  "virtualoffices.documentChecklist": "ドキュメントチェックリスト",
  "virtualoffices.languages": "言語",
  "tasks.tasks": "タスク",
  "tasks.noTasksYet": "タスクはまだありません",
  "tasks.dragTasksHere": "ここにタスクをドラッグ",
  "tasks.createNewTask": "新しいタスクを作成",
  "tasks.descriptionOptional": "説明（任意）",
  "tasks.relatedDealOptional": "関連案件（任意）",
  "tasks.noDealAttached": "案件が添付されていません",
  "tasks.assignees": "担当者",
  "tasks.noTeamMembersAvailable": "利用可能なチームメンバーはいません。アクティブなメンバーのみ割り当て可能です。",
  "tasks.cancel": "キャンセル",
  "tasks.description": "説明",
  "tasks.status": "ステータス",
  "tasks.relatedDeal": "関連案件",
  "tasks.noAssignees": "担当者なし",
  "tasks.areYouAbsolutelySure": "本当によろしいですか？",
  "events.events": "イベント",
  "events.tradeShowsWebinarsAnd": "展示会、ウェビナー、およびネットワーキングイベント",
  "events.createEvent": "イベントを作成",
  "events.title": "タイトル",
  "events.description": "説明",
  "events.category": "カテゴリー",
  "events.type": "タイプ",
  "events.locationUrl": "場所 / URL",
  "events.startDateTime": "開始日時",
  "events.endDateTime": "終了日時",
  "events.maxAttendeesOptional": "最大参加者数（任意）",
  "events.cancel": "キャンセル",
  "events.allCategories": "全カテゴリー",
  "events.noEventsFoundCreate": "イベントが見つかりません。最初のイベントを作成してください！",
  "events.featured": "注目",
  "events.previous": "前へ",
  "events.next": "次へ",
  "status.pendingDocuments": "書類待ち",
  "status.pendingSignature": "署名待ち",
  "status.pendingPayment": "支払い待ち",
  "status.completed": "完了",
  "status.updated": "更新済み",
  "status.onHold": "保留中",
  "activity.deal": "取引",
  "activity.action.analyzed": "分析済み",
  "activity.action.uploaded": "アップロード済み",
  "activity.action.downloaded": "ダウンロード済み",
  "activity.action.previewed": "プレビュー済み",
  "activity.action.shared": "共有済み",
  "activity.action.status_changed": "ステータス変更済み",
  "activity.action.updated": "更新済み",
  "activity.action.created": "作成済み",
  "activity.action.archived": "アーカイブ済み",
  "activity.action.restored": "復元済み",
  "analytics.totalRevenue": "総売上高",
  "analytics.totalDeals": "総取引数",
  "analytics.conversionRate": "コンバージョン率",
  "analytics.avgDealValue": "平均取引金額",
  "analytics.dealPipeline": "取引パイプライン",
  "analytics.monthlyRevenue": "月次売上高",
  "analytics.topClientsByRevenue": "売上高別上位顧客",
  "analytics.invoiceHealth": "請求書状況",
  "analytics.paid": "支払済み",
  "analytics.pendingPayment": "支払い待ち",
  "companyprofile.saveProfile": "プロフィールを保存",
  "companyprofile.makeVisible": "ディレクトリで会社を表示する",
  "companyprofile.tab.basicInfo": "基本情報",
  "companyprofile.tab.details": "詳細",
  "companyprofile.tab.contact": "連絡先",
  "companyprofile.tab.team": "チーム",
  "companyprofile.tab.verification": "認証",
  "companyprofile.selectType": "種別を選択",
  "companyprofile.describePlaceholder": "会社、製品、サービスについて説明してください...",
  "companyprofile.industry.other": "その他",
  "companyprofile.preview": "プレビュー",
  "companyprofile.ph.companyName": "貴社株式会社",
  "companyprofile.ph.tagline": "高品質な製品、グローバルな展開",
  "companyprofile.ph.selectIndustry": "業界を選択",
  "companyprofile.ph.selectSize": "規模を選択",
  "companyprofile.ph.certifications": "ISO 9001、CE、FDA（カンマ区切り）",
  "companyprofile.ph.languages": "日本語、スペイン語、中国語",
  "companyprofile.ph.exportRegions": "北米、ヨーロッパ、アジア",
  "companyprofile.ph.selectCountry": "国を選択",
  "companyprofile.ph.city": "ロサンゼルス",
  "companyprofile.ph.teamName": "チームメンバー名",
  "companyprofile.ph.addTitle": "役職を追加...",
  "companyprofile.inviteTeamMember": "チームメンバーを招待",
  "companyprofile.invitationSent": "招待を正常に送信いたしました",
  "virtualoffices.newOffice": "新規オフィス",
  "virtualoffices.createOffice": "バーチャルオフィスを作成",
  "virtualoffices.reviewChecklist": "書類チェックリストを確認",
  "virtualoffices.setupDesc": "お客様のビジネス向けに新しいブランド化されたワークスペースを設定",
  "virtualoffices.customizeDesc": "クライアントから必要な書類をカスタマイズ",
  "virtualoffices.ph.officeName": "例：ガルシア保険 - 自動車保険",
  "virtualoffices.ph.description": "オフィスの焦点について説明してください...",
  "virtualoffices.ph.addDocument": "カスタム書類を追加...",
  "virtualoffices.generating": "生成中...",
  "virtualoffices.aiChecklist": "AIが生成したチェックリスト：",
  "virtualoffices.clients": "クライアント",
  "virtualoffices.pending": "保留中",
  "virtualoffices.invite": "招待",
  "virtualoffices.ind.manufacturing": "製造業",
  "virtualoffices.ind.insurance": "保険業",
  "virtualoffices.ind.real_estate": "不動産業",
  "virtualoffices.ind.automotive": "自動車業",
  "virtualoffices.ind.import_export": "輸出入業",
  "virtualoffices.ind.other": "その他",
  "messages.conversations": "会話",
  "messages.searchPlaceholder": "メッセージを検索...",
  "messages.noConversations": "会話がありません",
  "messages.send": "送信",
  "messages.selectConversation": "会話を選択",
  "messages.selectConversationDesc": "サイドバーから会話を選択してチャットを開始してください",
  "messages.support": "サポート",
  "messages.client": "クライアント",
  "messages.deal": "取引",
  "meetings.subtitle": "ビデオ会議のスケジュール管理",
  "meetings.upcoming": "予定",
  "meetings.past": "過去",
  "meetings.schedule": "スケジュール",
  "meetings.startInstant": "今すぐ開始",
  "meetings.startNow": "今すぐ開始",
  "meetings.noPast": "過去の会議はございません",
  "meetings.noUpcoming": "予定されている会議はございません",
  "meetings.createMeeting": "会議を作成",
  "meetings.startInstantMeeting": "インスタント会議を開始",
  "meetings.scheduleMeeting": "会議をスケジュール",
  "meetings.scheduleDesc": "ビデオ会議をスケジュールし、招待状を送信いたします。",
  "meetings.invitePeople": "招待者（任意）",
  "meetings.15min": "15分",
  "meetings.30min": "30分",
  "meetings.45min": "45分",
  "meetings.allowRecording": "録画を許可",
  "meetings.recordingDesc": "ホストがこの会議を録画することを可能にします",
  "meetings.waitingRoom": "待機室",
  "meetings.waitingRoomDesc": "参加者は参加前にホストによる承認が必要です",
  "meetings.emailPlaceholder": "email@example.com",
  "meetings.cancelConfirm": "この会議をキャンセルいたしますか？",
  "meetings.cancelMeeting": "会議をキャンセル",
  "documents.title": "文書",
  "documents.viewAll": "すべて表示",
  "documents.archived": "アーカイブ済み",
  "documents.requestDocs": "文書要求",
  "documents.upload": "アップロード",
  "documents.allDocuments": "すべての文書",
  "documents.searchPlaceholder": "文書を検索...",
  "documents.addTag": "タグを追加...",
  "documents.uploadDesc": "ファイルをドラッグアンドドロップするか、クリックして参照してください。PDF、画像、Wordドキュメントをサポートしています。",
  "documents.emailPlaceholder": "client@example.com",
  "documents.shareMsgPlaceholder": "ご依頼いただいた文書をお送りします...",
  "documents.requestDesc": "メールでクライアントに安全なアップロードリンクを送信します。",
  "documents.namePlaceholder": "田中太郎",
  "documents.requestMsgPlaceholder": "以下の文書をアップロードしてください...",
  "documents.folderName": "フォルダ名",
  "documents.selectDestination": "宛先フォルダを選択してください。",
  "documents.statusUploaded": "アップロード済み",
  "documents.statusAnalyzed": "分析済み",
  "documents.statusArchived": "アーカイブ済み",
  "documents.allTypes": "すべての種類",
  "documents.inArchive": "アーカイブ内",
  "templates.allTemplates": "すべてのテンプレート",
  "templates.editTemplate": "テンプレートを編集",
  "templates.createCustomTemplate": "カスタムテンプレートを作成",
  "templates.editDesc": "文書テンプレートを更新",
  "templates.createDesc": "再利用可能な独自の文書テンプレートを作成",
  "templates.ph.templateName": "例：カスタム秘密保持契約",
  "templates.ph.description": "テンプレートの簡潔な説明",
  "templates.ph.content": "こちらにテンプレートの内容を入力してください...",
  "templates.saving": "保存中...",
  "templates.creating": "作成中...",
  "templates.saveChanges": "変更を保存",
  "templates.createTemplate": "テンプレートを作成",
  "templates.searchPlaceholder": "テンプレートを検索...",
  "templates.popularTemplates": "人気のテンプレート",
  "templates.defaultTemplates": "デフォルトテンプレート",
  "templates.deleteTemplate": "テンプレートを削除",
  "templates.preview": "プレビュー",
  "templates.description": "説明",
  "products.searchPlaceholder": "製品を検索...",
  "products.ph.service": "コンサルティングサービス",
  "products.ph.product": "ウィジェットプロ3000",
  "products.selectCategory": "カテゴリーを選択",
  "products.ph.describe": "製品またはサービスについて説明してください...",
  "products.noMatches": "一致する結果が見つかりません",
  "products.noProducts": "製品またはサービスはまだありません",
  "products.serviceDetails": "サービス詳細",
  "products.productDetails": "製品詳細",
  "products.inactive": "無効",
  "products.deleteConfirm": "この項目を削除しますか？",
  "products.saveChanges": "変更を保存",
  "products.addItem": "項目を追加",
  "products.priceOnRequest": "価格はお問い合わせください",
  "products.perUnit": "単位あたり",
  "tasks.searchPlaceholder": "タスクを検索...",
  "tasks.ph.title": "例：法的文書のレビュー",
  "tasks.ph.description": "このタスクにさらなる詳細を追加してください...",
  "tasks.selectDeal": "添付する取引を選択してください",
  "tasks.noTasks": "この列にはタスクがありません",
  "tasks.deleteTask": "タスクを削除",
  "settings.tabs.branding": "ブランディング",
  "settings.tabs.payments": "お支払い",
  "settings.tabs.plan": "プラン",
  "settings.tabs.integrations": "統合",
  "settings.appearance": "外観",
  "settings.saveBranding": "ブランディングを保存",
  "settings.yourPlan": "あなたのプラン",
  "settings.ph.logoUrl": "https://example.com/logo.png",
  "settings.ph.customDomain": "deals.yourcompany.com",
  "settings.calendarFeedGenerated": "カレンダーフィードURLが生成されました！",
  "settings.plan.free": "フリー",
  "settings.plan.pro": "プロ",
  "settings.plan.smallBusiness": "スモールビジネス",
  "settings.plan.businessPro": "ビジネスプロ",
  "settings.plan.scale": "スケール",
  "settings.plan.enterprise": "エンタープライズ",
  "dealroom.meetings": "ミーティング",
  "dealroom.startMeeting": "ミーティングを開始",
  "dealroom.noMeetings": "この案件にはまだミーティングがリンクされていません",
  "dealroom.noMeetingsDesc": "開始するにはミーティングを開始するかスケジュールしてください",
  "dealroom.failedCreateMeeting": "ミーティングの作成に失敗しました",
  "dealroom.finalizedContract": "最終契約書 — 署名準備完了",
  "dealroom.previewNotSupported": "プレビューはサポートされていません",
  "dealroom.aiMayTakeMoment": "しばらくお時間をいただく場合があります。",
  "dealroom.aiAnalysisGenerated": "以下の文書に対してAI分析が生成されました：",
  "dealroom.docsUnanalyzed": "以下の文書は未分析のままです：",
  "dealroom.analyzingDocs": "文書を分析中...",
  "dealroom.finalizeWarning": "この操作は元に戻すことができません。案件のステータスが署名待ちに変更され、すべての関係者が契約書に署名できるようになります。",
  "dealroom.cannotRevert": "署名待ちから元に戻すことはできません",
  "compliance.ph.productDesc": "例：ステンレス鋼ボルト、M10 x 50mm...",
  "compliance.ph.exportDesc": "輸出される製品または技術について説明してください...",
  "compliance.select": "選択してください...",
  "compliance.selectCountry": "国を選択してください...",
  "events.tradeShow": "展示会",
  "events.webinar": "ウェビナー",
  "events.networking": "ネットワーキング",
  "events.conference": "カンファレンス",
  "events.workshop": "ワークショップ",
  "events.ph.title": "イベントタイトル",
  "events.ph.location": "会場住所または会議URL",
  "events.ph.maxAttendees": "無制限の場合は空欄にしてください",
  "events.searchPlaceholder": "イベントを検索...",
  "events.cancelRsvp": "RSVPをキャンセル",
  "events.rsvp": "RSVP",
  "rfq.expired": "期限切れ",
  "rfq.createRfq": "RFQを作成",
  "rfq.visibility": "公開設定",
  "rfq.public": "公開 - すべてのサプライヤーが閲覧可能",
  "rfq.private": "非公開 - 招待のみ",
  "rfq.quantity": "数量",
  "rfq.unit": "単位",
  "rfq.pieces": "個",
  "rfq.kilograms": "キログラム",
  "rfq.meters": "メートル",
  "rfq.squareMeters": "平方メートル",
  "rfq.units": "ユニット",
  "rfq.sets": "セット",
  "rfq.boxes": "箱",
  "rfq.deliveryLocation": "納入場所",
  "rfq.deliveryDeadline": "納期",
  "rfq.specialRequirements": "特別要件",
  "rfq.title": "見積依頼",
  "rfq.subtitle": "調達依頼を閲覧するか、ご自身の依頼を投稿してください",
  "rfq.rfqsPosted": "投稿されたRFQ数",
  "rfq.openRfqs": "オープンRFQ",
  "rfq.quotesSent": "送信済み見積数",
  "rfq.winRate": "受注率",
  "rfq.allCategories": "すべてのカテゴリー",
  "rfq.noRfqsFound": "RFQが見つかりません",
  "rfq.noRfqsYet": "まだRFQがありません",
  "meetings.biweekly": "隔週",
  "meetings.cancelSeries": "シリーズ全体をキャンセル",
  "meetings.cancelThisMeeting": "このミーティングをキャンセル",
  "meetings.nextInSeries": "シリーズの次",
  "nav.contractTemplates": "契約書",
  "contracts.title": "契約書テンプレート",
  "contracts.subtitle": "AI搭載の法的文書作成。テンプレートを選択して開始してください。",
  "documents.create": "作成",
  "createDoc.untitledDocument": "無題のドキュメント",
  "createDoc.save": "保存",
  "createDoc.export": "エクスポート",
  "createDoc.aiAssist": "AIアシスト",
  "createDoc.generate": "生成",
  "createDoc.generating": "生成中...",
  "createDoc.cancel": "キャンセル",
  "createDoc.translate": "翻訳",
  "createDoc.translateTitle": "ドキュメントを翻訳",
  "createDoc.translateTo": "翻訳先",
  "createDoc.translateNow": "翻訳",
  "createDoc.translating": "翻訳中...",
  "createDoc.translated": "ドキュメントの翻訳が完了しました",
  "createDoc.translateFailed": "翻訳に失敗しました",
  "verification.status": "認証ステータス",
  "verification.inProgress": "認証進行中",
  "verification.getVerified": "認証を取得",
  "verification.cancelRequest": "リクエストをキャンセル",
  "verification.submit": "認証を申請",
  "verification.submitting": "送信中...",
  "verification.uploadDocs": "書類をアップロード",
  "verification.level": "認証レベル",
  "verification.selectDocType": "書類タイプを選択...",
  "contracts.generate": "生成",
  "contracts.backToTemplates": "テンプレートに戻る",
  "contracts.required": "必須",
  "contracts.modify": "変更",
  "contracts.finalize": "確定",
  "contracts.applyChanges": "変更を適用",
  "contracts.confirmDelete": "この下書きを削除しますか？",
  "contracts.generating": "ドキュメント生成中...",
  "templates.deleting": "削除中...",
  "templates.noDescription": "説明なし。",
  "templates.use": "使用",
  "templates.lib.ndaMutual": "相互秘密保持契約",
  "templates.lib.purchaseAgreement": "購入契約",
  "templates.lib.serviceAgreement": "サービス契約",
  "templates.lib.priceQuote": "見積書",
  "templates.lib.invoice": "請求書",
  "templates.lib.loi": "意向表明書",
  "settings.security": "セキュリティ",
  "security.twoFactor": "二要素認証",
  "security.enabled": "有効",
  "security.disabled": "無効",
  "security.enable2FA": "2FAを有効化",
  "security.disable": "無効化",
  "security.activeSessions": "アクティブセッション",
  "security.logoutAll": "すべてログアウト",
  "security.loginHistory": "ログイン履歴",
  "security.verify": "確認",
  "security.cancel": "キャンセル",
  "security.password": "パスワード",
  "security.done": "完了",
  "feedback.button": "フィードバック",
  "feedback.title": "フィードバックを送信",
  "feedback.typeBug": "バグ",
  "feedback.typeFeature": "機能",
  "feedback.typeGeneral": "一般",
  "feedback.submit": "送信",
  "feedback.thanks": "ありがとうございます！確認します。",
};

export default ja;
